import { QueryClient, UseQueryResult } from 'react-query';
import { canRetryError } from './request';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: (failureCount, error) => {
        return !failureCount && canRetryError(error);
      },
      cacheTime: 1000,
      staleTime: 1000,
    },
  },
});

export function compareQuery<D>(a: UseQueryResult<D>, b: UseQueryResult<D>): boolean {
  return (
    a.data === b.data &&
    a.status === b.status &&
    a.dataUpdatedAt === b.dataUpdatedAt &&
    a.errorUpdatedAt === b.errorUpdatedAt
  );
}

export function compareQueries<D>(a: UseQueryResult<D>[], b: UseQueryResult<D>[]): boolean {
  return a === b || (a?.length === b?.length && a.every((q, i) => compareQuery(q, b[i])));
}

export const queryCache = queryClient.getQueryCache();

export default queryClient;
